module.exports = __webpack_public_path__ + "static/img/07.56bed7d2.png";